module.exports = __webpack_public_path__ + "static/media/symbol_icon.fragment.84299900.glsl";